"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfile = void 0;
const Leaf = __importStar(require("leaf-ts"));
const nanoid = __importStar(require("nanoid"));
const web_consensus_1 = require("@branch-ts/web-consensus");
const web_1 = require("@branch-ts/web");
const seqop_consensus_1 = require("@branch-ts/seqop-consensus");
const verse_consensus_1 = require("@branch-ts/verse-consensus");
const verset_consensus_1 = require("@project/verset_consensus");
const userProfile_html_R_1 = require("./userProfile.html.R");
const userProfile_html_R_2 = require("./userProfile.theme/business/userProfile.html.R");
const userProfile_html_R_3 = require("./userProfile.theme/genesis/userProfile.html.R");
const subscriptionPanel_1 = require("./subscriptionPanel");
const subscriptionTier_1 = require("./subscriptionTier");
const versetFacilityMechanism_1 = require("../versetFacilityMechanism");
const versetUserProfileMechanism_1 = require("../versetUserProfileMechanism");
class UserProfile extends userProfile_html_R_1.R.UserProfile {
    constructor() {
        super();
        this.presentContext = web_consensus_1.PresentMechanism.ensure(this)
            .lifeCycle(async (declares) => {
            await declares.declare("present");
            await this.refresh();
            await declares.declare("hang");
        });
        this.subscriptionPanel = new subscriptionPanel_1.SubscriptionPanel();
        this.stages = new web_1.StagesBehavior(this).defines({ additionalUsage: "hide" });
        this.fault = (0, web_1.FatUIErrorBestPractice)();
        versetUserProfileMechanism_1.VersetUserProfileMechanism.events.of.refresh.listenBy(this, () => {
            void this.refresh();
        });
    }
    async refresh() {
        const search = new URL(window.location.href).searchParams;
        if (search.get("section") === "subscription") {
            this.subscriptionPanel.node?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
        const server = versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer();
        const [profileRes, profileReason, ...profileErrors] = await server.rpcs.VersetUserProfileService.getMyDashboardProfile({});
        if (profileReason) {
            const errorDetail = profileErrors
                .map(error => error?.message || String(error))
                .filter(Boolean)
                .join(" ");
            console.error("Verset dashboard profile RPC failed", {
                reason: profileReason,
                errors: profileErrors,
            });
            this.fault.caution.worry({
                message: `Failed to get dashboard profile: ${profileReason}${errorDetail ? ` ${errorDetail}` : ""}`,
                reason: profileReason,
                errors: profileErrors,
            });
        }
        const profile = profileRes?.profile;
        const account = profile?.account;
        const handles = profile?.handles || [];
        const billing = profile?.billing;
        const displayName = account?.displayName || account?.id || "User";
        const accountId = account?.id || "Unavailable";
        const balanceView = this.makeBalanceView(billing?.balances || [], billing?.pointType || "vp");
        const primaryEmail = handles.find(handle => handle.type === "email")?.handle || "Not bound";
        const currentPlan = billing?.subscriptionPlan?.name || billing?.subscription?.plan || "free";
        const subscriptionState = billing?.subscription?.state || "free";
        const inPlanCreditResetAt = billing?.inPlanCreditResetAt;
        this.stages.set("additionalUsage", billing?.subscription?.state.startsWith("active") && currentPlan !== "free" ? "show" : "hide");
        this.VM.displayName = displayName;
        this.VM.accountId = accountId;
        this.VM.primaryEmail = primaryEmail;
        this.VM.currentPlan = currentPlan;
        const tier = (0, subscriptionTier_1.subscriptionTier)(billing?.subscription);
        this.VM.tierName = tier.name;
        this.VM.tierClass = tier.className;
        this.VM.subscriptionState = subscriptionState;
        this.VM.inPlanBalance = `${balanceView.inPlan} ${balanceView.pointType}`;
        this.VM.inPlanCreditResetAt = inPlanCreditResetAt
            ? new Date(inPlanCreditResetAt).toLocaleString()
            : "Unavailable";
        this.VM.permanentBalance = `${balanceView.permanent} ${balanceView.pointType}`;
        await this.subscriptionPanel.refresh();
    }
    makeBalanceView(balances, pointType) {
        const inPlan = balances.find(balance => balance.type === "inPlan")?.spendable || 0;
        const permanent = balances.find(balance => balance.type === "permanent")?.spendable || 0;
        return {
            inPlan,
            permanent,
            pointType,
        };
    }
    onClickOpenBillingHistory(e) {
        e?.stopPropagation();
        e?.preventDefault();
        window.location.href = "/dashboard/billing";
    }
    async onClickLogout(e) {
        e?.stopPropagation();
        e?.preventDefault();
        if (this.UI.logout.disabled)
            return;
        this.UI.logout.disabled = true;
        try {
            const confirmed = await web_consensus_1.CommonUI.confirm("Log out of Verset on this device? This clears locally saved account details, cookies, and offline data. Unsynced changes will be lost. Your account and cloud content will not be deleted.");
            if (!confirmed)
                return;
            await web_consensus_1.CommonUI.loading(this.UI.logout).during(() => web_consensus_1.LogoutMechanism.logout());
            if (web_consensus_1.LogoutMechanism.getResult()?.complete === false) {
                web_consensus_1.CommonUI.toast("Logged out with a warning: some cleanup or server revocation could not be confirmed.");
            }
        }
        catch (error) {
            this.fault.caution.worry({
                message: "An unexpected error occurred while leaving Verset. Reload this page and check your server sessions.",
                reason: "LogoutError",
                errors: [error],
            });
        }
        finally {
            this.UI.logout.disabled = false;
        }
    }
    onClickAddCredit(e) {
        e?.stopPropagation();
        e?.preventDefault();
        versetFacilityMechanism_1.VersetFacilityMechanism.ensureApp().getServiceByName("VersetBillingService").showGate({
            source: "Additional AI usage",
        });
    }
    async onClickExportVerse(e) {
        e?.stopPropagation();
        e?.preventDefault();
        const verse = versetFacilityMechanism_1.VersetFacilityMechanism.agreement?.particulars.versetWebapp.verse.userMainVerseURI;
        if (!verse) {
            this.fault.caution.worry({
                message: "Your main verse is not available for export yet.",
                reason: "NotAvailable",
                errors: [],
            });
            return;
        }
        const mediator = seqop_consensus_1.MediatorRegistryMechanism.ensure({
            uri: verse,
        });
        await mediator.wait();
        const content = JSON.stringify({
            verse: mediator.graph.toJSON(),
        }, null, 2);
        const blob = new Blob([content], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = "verset.json";
        anchor.click();
        URL.revokeObjectURL(url);
    }
    async onClickNewTutorial(e) {
        e?.stopPropagation();
        e?.preventDefault();
        const verse = versetFacilityMechanism_1.VersetFacilityMechanism.agreement?.particulars.versetWebapp.verse.userMainVerseURI;
        if (!verse) {
            this.fault.caution.worry({
                message: "Your main verse is not available yet.",
                reason: "NotAvailable",
                errors: [],
            });
            return;
        }
        try {
            const mediator = seqop_consensus_1.MediatorRegistryMechanism.ensure({
                uri: verse,
            });
            await mediator.wait();
            const projectSid = nanoid.nanoid();
            const projectName = this.getNewTutorialProjectName(mediator);
            const [, projectReason, ...projectErrors] = await mediator.conduct({
                action: {
                    kind: "create",
                    entity: "project",
                    create: {
                        sid: projectSid,
                        name: projectName,
                        role: "project",
                        order: seqop_consensus_1.Order.between(mediator.projects()
                            .sort(seqop_consensus_1.Order.compareOf(project => project.order))
                            .at(-1)?.order || null, null).toString(),
                    },
                },
            });
            if (projectReason) {
                throw new Error([projectReason, ...projectErrors.map(String)].join(" "));
            }
            await this.createTutorialEntries({
                mediator,
                entries: verset_consensus_1.TutorialEntries,
                of: projectSid,
            });
            web_consensus_1.CommonUI.toast(`${projectName} created successfully.`);
            web_consensus_1.UIMechanism.goto({ uri: "/singular" });
            web_consensus_1.UIMechanism.goto({
                uri: verse_consensus_1.VerseProtocol.VerseItemURI.build({
                    kind: "project",
                    verseId: mediator.uriInfo.id,
                    sid: projectSid,
                }),
            });
        }
        catch (error) {
            this.fault.caution.worry({
                message: "Could not create a new tutorial.",
                reason: "Unknown",
                errors: [error],
            });
        }
    }
    getNewTutorialProjectName(mediator) {
        const projectNames = new Set(mediator.projects().map(project => project.name));
        let number = 2;
        while (projectNames.has(`Tutorial ${number}`)) {
            number++;
        }
        return `Tutorial ${number}`;
    }
    async createTutorialEntries(option) {
        const orders = seqop_consensus_1.Order.balanced(option.entries.length).map(order => order.toString());
        for (const [index, entry] of option.entries.entries()) {
            const sid = nanoid.nanoid();
            const [, reason, ...errors] = await option.mediator.conduct({
                action: {
                    kind: "create",
                    entity: "entry",
                    create: {
                        sid,
                        of: option.of,
                        brief: entry.brief,
                        orderAsStep: orders[index],
                    },
                },
            });
            if (reason) {
                throw new Error([reason, ...errors.map(String)].join(" "));
            }
            await this.createTutorialEntries({
                mediator: option.mediator,
                entries: entry.steps || [],
                of: sid,
            });
        }
    }
}
exports.UserProfile = UserProfile;
Leaf.WidgetThemeCenter.about(userProfile_html_R_1.R.UserProfile).add("business", userProfile_html_R_2.R.UserProfile.generator);
Leaf.WidgetThemeCenter.about(userProfile_html_R_1.R.UserProfile).add("genesis", userProfile_html_R_3.R.UserProfile.generator);
